package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.TotpSetupResponse
import com.example.readingnotes.domain.repository.AuthRepository
import com.example.readingnotes.util.Result

class SetupTotpUseCase(
    private val authRepository: AuthRepository,
) {
    suspend operator fun invoke(): Result<TotpSetupResponse> = authRepository.setupTotp()
}
